import React from "react";
import PropTypes from "prop-types";
import { Transition, Segment, Feed } from "semantic-ui-react";
import Incidencia from "./incidenciasAlumno/Incidencia";
import shortid from "shortid";
import ModalComentarios from "../shared/ModalComentarios";
import _ from "lodash";

class IncidenciasAlumnos extends React.Component {
  state = { visible: false };

  componentDidMount() {
    setTimeout(
      () =>
        this.setState({
          visible: true
        }),
      250
    );
  }

  handleClick = (tipo, id, texto) => {
    switch (tipo) {
      case "cerrar":
        this.props.cerrarIncidencia(id);
        break;

      case "guardar":
        this.props.guardarIncidencia(id, texto);
        break;

      default:
        break;
    }
  };

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Segment>
            <Segment basic textAlign="center">
              <ModalComentarios
                headerText={`Incidencia de ${this.props.nombreAlumno}`}
                color="pink"
                content={""}
                onSave={(id, texto) => this.handleClick("guardar", id, texto)}
                icon="add"
                buttonText="Añadir nueva incidencia"
              />
            </Segment>
            {!_.isEmpty(this.props.incidencias) && (
              <Feed>
                {this.props.incidencias.map(item => (
                  <Incidencia
                    key={shortid.generate()}
                    handleClick={this.handleClick}
                    incidencia={item}
                    nombreAlumno={this.props.nombreAlumno}
                  />
                ))}
              </Feed>
            )}
          </Segment>
        )}
      </Transition.Group>
    );
  }
}

IncidenciasAlumnos.propTypes = {
  cerrarIncidencia: PropTypes.func,
  guardarIncidencia: PropTypes.func,
  incidencias: PropTypes.array,
  nombreAlumno: PropTypes.string
};

export default IncidenciasAlumnos;



// WEBPACK FOOTER //
// ./src/pages/detalleAlumno/IncidenciasAlumno.jsx